module.exports = __webpack_public_path__ + "static/img/liu.4304436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/liu.jpg
// module id = HgF3
// module chunks = 1